import React from "react";
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";

import { lisbonDateLabel, lisbonTime } from "../../utils/format";
import { ACTION_LABELS, TARGET_TYPE_LABELS } from "../constants";
import {
  ActivityDetails,
  ActivityMeta,
  ActivityRow,
  ActivityRows,
  ActivitySummary,
  ActivityTime,
  TargetPill,
} from "../styles";
import { ActivityListProps } from "../types";
import { targetOf } from "../utils/describeRecord";
import { ActivityRecordDetail } from "./ActivityRecordDetail";

export const ActivityList: React.FC<ActivityListProps> = ({ records }) => (
  <ActivityRows aria-label="Activity records">
    {records.map((record) => (
      <ActivityRow key={record.id}>
        <ActivityDetails>
          <ActivitySummary>
            <ActivityTime dateTime={record.createdAt}>
              <strong>{lisbonTime(record.createdAt)}</strong>
              <span>{lisbonDateLabel(record.createdAt)}</span>
            </ActivityTime>
            <ActivityMeta>
              <strong>{ACTION_LABELS[record.action]}</strong>
              <span>{targetOf(record)}</span>
            </ActivityMeta>
            <TargetPill $tone="neutral">
              {TARGET_TYPE_LABELS[record.targetType]}
            </TargetPill>
            <ChevronRightRoundedIcon fontSize="small" aria-hidden />
          </ActivitySummary>
          <ActivityRecordDetail record={record} />
        </ActivityDetails>
      </ActivityRow>
    ))}
  </ActivityRows>
);
